import { render, staticRenderFns } from "./hazardous.vue?vue&type=template&id=02a115b4&scoped=true"
import script from "./hazardous.vue?vue&type=script&lang=js"
export * from "./hazardous.vue?vue&type=script&lang=js"
import style0 from "./hazardous.vue?vue&type=style&index=0&id=02a115b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a115b4",
  null
  
)

export default component.exports